import React from 'react';
import GenericSummaryDesktop from '../generic-summary/generic-summary.desktop';
import { vehicleReservationDataShape } from './prop-types';

const namespace = 'vehicle-reservation-with-credit';

const VehicleReservationGenericSummary = ({ data }) => {
  const dynamicData = {
    title: {
      text: data?.title?.text,
      color: data?.title?.color,
    },
    subtitles: data?.subtitles?.map(subtitle => ({
      text: subtitle?.text,
      color: subtitle?.color,
    })),
    action: {
      target: data?.action?.target,
      label: {
        text: data?.action?.label?.text,
        color: data?.action?.label?.color,
        font_size: data?.action?.label?.font_size,
        font_family: data?.action?.label?.font_family,
        text_icon: data?.action?.label?.text_icon,
      },
      disabled: data?.action?.disabled,
      action_type: data?.action?.action_type,
      html_target: '_blank',
    },
  };

  return (
    <div className={`${namespace}__credit`}>
      <GenericSummaryDesktop {...dynamicData} />
    </div>
  );
};

VehicleReservationGenericSummary.propTypes = {
  data: vehicleReservationDataShape,
};

export default VehicleReservationGenericSummary;
